import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppService } from "@App";
import { IConfigService } from "@Config";
import { ReviewedObjectRequest } from "@Models/case/reviewed-object.request";
import { BaseService } from "@Services";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CaseNoteService extends BaseService {
    publicApiBaseUrl: string;

   constructor(
        public configService: IConfigService,
        public httpClient: HttpClient,
        public appService: AppService
    ) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    markObjectAsReviewed(request: ReviewedObjectRequest, clientId: string, caseId: string): Observable<any> {
        return super.postData<ReviewedObjectRequest>(`${this.publicApiBaseUrl}client/${clientId}/case/${caseId}/mark-as-reviewed`, request);
    }
}